const vue_progress_bar_options = {
    color: '#bffaf3',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '0.1s',
        opacity: '0.2',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

export default vue_progress_bar_options